'use client';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress } from '@mui/material';
import { useLazyQuery } from '@parkchirp/api-client';
import React, { useState } from 'react';

import { SetShowSnackbar } from '../../types';

interface CsvExportButtonV2Props {
	query: any;
	queryName: string;
	args: any;
	disabled?: boolean;
	buttonText?: string;
	setShowSnackbar?: SetShowSnackbar;
}

export const CsvExportButtonV2 = ({
	query,
	queryName,
	args,
	disabled = false,
	buttonText = 'Export',
	setShowSnackbar,
}: CsvExportButtonV2Props): JSX.Element => {
	const [downloadInitiated, setDownloadInitiated] = useState<boolean>(false);
	const [downloadCSV] = useLazyQuery(query);

	const handleDownload = () => {
		setDownloadInitiated(true);
		downloadCSV({
			...args,
			fetchPolicy: 'network-only',
			onCompleted: (response) => {
				setDownloadInitiated(false);
				window.open(response[queryName].url);
			},
			onError: (err) => {
				if (setShowSnackbar) {
					setShowSnackbar({
						message: err.message,
						severity: 'error',
					});
				}
				setDownloadInitiated(false);
			},
		});
	};

	return (
		<Button size='small' startIcon={<DownloadIcon />} onClick={handleDownload} disabled={disabled}>
			<span style={{ marginRight: '5px' }}>{buttonText}</span>
			{downloadInitiated && <CircularProgress style={{ height: '20px', width: '20px' }} />}
		</Button>
	);
};
